<template>
    <AdminBlock :title="'Invoiceable Jobs for ' + customer.name">
        <table class="table table-bordered table-striped table-vcenter dataTable" ref="datatablePickJobsList" style="width: 100%;">
            <thead>
                <tr>
                    <th>Pick for Invoice</th>
                    <th>Job Ref</th>
                    <th>Contract</th>
                    <th>Purchase Order</th>
                    <th>Vehicle</th>
                    <th>Journey</th>
                    <th>Collection Date</th>
                    <th>Delivery Date</th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </AdminBlock>
</template>

<script>

import AdminBlock from "@/components/movements/components/AdminBlock.vue";

export default {
    components: {
        AdminBlock
    },
    props: {
        ajaxUrl: String,
        jobs: {
            type: Array,
            default: () => [],
            required: false
        },
        customer: {
            type: Object,
            default: () => {},
            required: true
        }
    },

    mounted() {

        const table = window.jQuery(this.$refs.datatablePickJobsList).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            data: this.jobs,
            order: [[0, 'desc']],
            columns: [
                {
                    data: 'id',
                    orderable: false,
                    searchable: false,
                    width: '70px',
                    render: function (data, type, row) {
                        return '<input type="checkbox" name="job_ids[]" value="' + row.id + '">';
                    }
                },
                {
                    data: 'reference',
                },
                {
                    data: 'contract.name'
                },
                {
                    data: 'client_ref'
                },
                {
                    data: 'vehicle.reg'
                },
                {
                    searchable: false,
                    orderable: false,
                    width: '200px',
                    render: function (data, type, row) {
                        return row.collection_locale + '<br> to ' + row.delivery_locale;
                    },
                },
                {
                    data: 'collection_date'
                },
                {
                    data: 'delivery_date'
                },
            ]
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );

    }
}
</script>
